import {Swiper} from 'swiper';
import {Navigation} from 'swiper/modules';

export class Slider {
    constructor() {
        this.sliders = document.querySelectorAll('[data-slider="slider-trigger"]');
        this.prevArrow = document.querySelectorAll('.slider-button-prev');
        this.nextArrow = document.querySelectorAll('.slider-button-next');

        this.initSlider();
    }

    initSlider() {
        Swiper.use([Navigation]);

        this.sliders?.forEach((slider, idx) => {
            const amountSlides = slider.getAttribute('data-slider-amount');
            let amountSlidesMinWidth = 1;

            if (amountSlides > 1) {
                amountSlidesMinWidth = 3;
            }

            let sliderOption = {
                spaceBetween: 16,
                slidesPerView: amountSlidesMinWidth,
                navigation: {
                    nextEl: this.nextArrow[idx],
                    prevEl: this.prevArrow[idx],
                },
                breakpoints: {
                    1024: {
                        spaceBetween: 128,
                        slidesPerView: amountSlides,
                    },
                    1280: {
                        spaceBetween: 256,
                        slidesPerView: amountSlides,
                    },
                },
            };

            new Swiper(slider, sliderOption);
        });
    }
}
